<div>
    <div *ngFor="let item of items">
        <div>
            {{ item.quantity }}x {{ item.name }} (${{
                item.list_price || item.price
            }})
        </div>
        <div *ngIf="item.subLabel" class="text-sm text-gray-400">
            {{ item.subLabel }}
        </div>
    </div>
</div>
